module.exports = __webpack_public_path__ + "static/media/29EUNOG19.649109c3.jpg";